import { useState } from "react";
import { Link } from "react-router-dom";
import { stars } from "@/mocks/stars";

interface CastListProps {
  castNames: string[];
}

export default function CastList({ castNames }: CastListProps) {
  const [openName, setOpenName] = useState<string | null>(null);
  const cast = castNames
    .map((name) => stars.find((s) => s.name === name))
    .filter((s): s is (typeof stars)[number] => Boolean(s));

  if (cast.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {cast.map((star) => (
        <div key={star.id} className="rounded-lg border border-background-200 bg-background-50 p-4">
          <div className="flex items-center gap-3">
            <Link to="/stars" className="cursor-pointer">
              <div className="h-14 w-14 overflow-hidden rounded-full bg-background-200">
                <img
                  src={star.avatar}
                  alt={`${star.name}头像`}
                  title={`${star.name} - 激情视频`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Link>
            <div className="min-w-0">
              <Link
                to="/stars"
                className="block truncate text-base font-semibold text-foreground-950 hover:text-primary-600 cursor-pointer"
              >
                {star.name}
              </Link>
              <p className="truncate text-xs text-foreground-500">{star.role}</p>
            </div>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{star.bio}</p>
          <button
            type="button"
            onClick={() => setOpenName(openName === star.name ? null : star.name)}
            className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            {openName === star.name ? "收起作品" : "更多该演员作品"}
            <i className={openName === star.name ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
          </button>
          {openName === star.name && (
            <ul className="mt-2 flex flex-wrap gap-2">
              {star.works.map((work) => (
                <li key={work}>
                  <Link
                    to={`/search?q=${encodeURIComponent(work)}`}
                    className="inline-flex rounded-md border border-background-200 bg-background-100 px-2.5 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                  >
                    {work}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}